<template>
    <section class="max-w-screen-xl px-4 py-10 mx-auto lg:py-12 lg:gap-y-8">
        <div class="grid grid-cols-12 lg:gap-x-12 gap-y-8">
            <div
                class="relative z-20 grid items-center order-2 col-span-12 md:my-16 lg:col-span-3 lg:order-1 lg:max-w-full">
                <nuxt-img :width="mainImageWidth" :height="mainImageHeight" format="webp" :src="mainImageSrc"
                    :alt="mainImageAlt"
                    class="object-cover w-full max-w-xs mx-auto sm-max:w-64 md:max-w-sm lg:absolute lg:max-w-md xl:-bottom-52 lg:left-0 lg:min-w-64 xl:min-w-[340px]"
                    loading="lazy" sizes="xs:330px sm:343px md:256px lg:384px xl:343" />
            </div>

            <div class="grid items-center order-1 col-span-12 lg:px-4 lg:col-span-9 lg:order-2">
                <div class="">
                    <h3 class="mb-4 text-center uppercase h1 font-ww-light lg:text-5xl" v-html="titleText"></h3>
                    <p class="text-center uppercase font-ww-light h2" v-html="subtitleText"></p>
                    <div
                        class="grid items-start max-w-2xl grid-cols-1 mx-auto mt-8 sm:grid-cols-2 gap-y-10 lg:gap-x-20 gap-x-8">
                        <div class="flex items-start gap-x-4" v-for="(item, index) in items" :key="index">
                            <div class="basis-12">
                                <nuxt-img :width="item.width" :height="item.height" format="webp" :src="item.src"
                                    :alt="item.alt" class="object-cover pt-1" loading="lazy" />
                            </div>
                            <div class="text-p basis-full">
                                <span class="pr-1 font-bold" v-html="item.title"></span>
                                <span v-html="item.description"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

const props = defineProps({
    mainImageSrc: {
        type: String,
        default: '/assets/images/icon-product-1.png'
    },
    mainImageAlt: {
        type: String,
        default: 'section image'
    },
    mainImageWidth: {
        type: Number,
        default: 343
    },
    mainImageHeight: {
        type: Number,
        default: 578
    },
    titleText: {
        type: String,
        default: "Get The Best Single Origin Coffee Beans In A frosted sugar cookie Coffee Flavor!"
    },
    subtitleText: {
        type: String,
        default: "Act Now As We Have A VERY Limited Supply"
    },
    items: {
        type: Array,
        default: () => [
            {
                src: '/assets/images/icon-low.png',
                alt: 'section image',
                title: "Low acid Medium Roast Coffee Beans",
                description: '(Specialty Arabica Beans)',
                width: 41,
                height: 42
            },
            {
                src: '/assets/images/icon-shade.png',
                alt: 'section image',
                title: "Shade And Elevation Grown",
                description: '(Slow Grown In The Mountains Of Nicaragua For Optimal Flavor And Low Acidity)',
                width: 45,
                height: 39
            },
            {
                src: '/assets/images/icon-farm.png',
                alt: 'section image',
                title: "Single Origin From Small Farms",
                description: 'In A Nationally Protected Area',
                width: 55,
                height: 43
            },
            {
                src: '/assets/images/fairly.png',
                alt: 'section image',
                title: "Fairly Traded",
                description: '(Our Coffee Farmers Are Paid A Fair Wage)',
                width: 44,
                height: 47
            }
        ]
    }
});

defineBuilderComponent({
    friendlyName: 'Image With Icons List',
    inputs: [
        {
            name: 'mainImageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
            defaultValue: '/assets/images/icon-product-1.png'
        },
        {
            name: 'mainImageAlt',
            type: 'text',
            defaultValue: 'section image'
        },
        {
            name: 'mainImageWidth',
            type: 'number',
            defaultValue: 343
        },
        {
            name: 'mainImageHeight',
            type: 'number',
            defaultValue: 578
        },
        {
            name: 'titleText',
            type: 'richText',
            defaultValue: 'Get The Best Single Origin Coffee Beans In A frosted sugar cookie Coffee Flavor!'
        },
        {
            name: 'subtitleText',
            type: 'richText',
            defaultValue: 'Act Now As We Have A VERY Limited Supply'
        },
        {
            name: 'items',
            type: 'list',
            defaultValue: [
                {
                    src: '/assets/images/icon-low.png',
                    alt: 'section image',
                    title: 'Low acid Medium Roast Coffee Beans',
                    description: '(Specialty Arabica Beans)',
                    width: 41,
                    height: 42
                },
                {
                    src: '/assets/images/icon-shade.png',
                    alt: 'section image',
                    title: 'Shade And Elevation Grown',
                    description: '(Slow Grown In The Mountains Of Nicaragua For Optimal Flavor And Low Acidity)',
                    width: 45,
                    height: 39
                },
                {
                    src: '/assets/images/icon-farm.png',
                    alt: 'section image',
                    title: 'Single Origin From Small Farms',
                    description: 'In A Nationally Protected Area',
                    width: 55,
                    height: 43
                },
                {
                    src: '/assets/images/fairly.png',
                    alt: 'section image',
                    title: 'Fairly Traded',
                    description: '(Our Coffee Farmers Are Paid A Fair Wage)',
                    width: 44,
                    height: 47
                }
            ],
            subFields: [
                {
                    name: 'src',
                    type: 'file',
                    allowedFileTypes: [
                        'jpeg',
                        'jpg',
                        'png',
                        'svg'
                    ],
                    defaultValue: '/assets/images/icon-low.png'
                },
                {
                    name: 'alt',
                    type: 'text',
                    defaultValue: 'section image'
                },
                {
                    name: 'title',
                    type: 'richText',
                    defaultValue: 'Low acid Medium Roast Coffee Beans'
                },
                {
                    name: 'description',
                    type: 'richText',
                    defaultValue: '(Specialty Arabica Beans)'
                },
                {
                    name: 'width',
                    type: 'number',
                    defaultValue: 41
                },
                {
                    name: 'height',
                    type: 'number',
                    defaultValue: 42
                }
            ]
        }
    ]
});
</script>
